<template>
  <article id="article-create">
    <header class="header-create">
      <h1>{{ planInfo ? planInfo.title : 'Unknown' }}</h1>
      <p>{{ planInfo.description }}</p>
    </header>

    <saving-compare v-if="plan=='plus'" :initial="this.objQuery.initial" @return="updateReturn"></saving-compare>

    <div v-for="(obj, index) in this.inputs" :key="index">
      <section class="section-input" v-if="obj.type == 'range'">
        <slide-input
          :label="obj.label"
          :name="obj.name"
          :min="obj.min"
          :max="obj.max"
          :interval="obj.interval"
          :default="obj.default"
          @input-range="inputData"
        />
      </section>

      <section class="section-input-checked" v-else-if="obj.type == 'radioBox'">
        <radio-list
          :label="obj.label"
          :items="obj.items"
          :name="obj.name"
          :default="obj.default"
          @input-checked-list="inputData"
        />
      </section>
    </div>

    <div class="spacer"></div>

    <section id="cta-create">
      <a class="cta-btn" @click="submitCreate" :class="{disable:isCreating}">
        <i class="fas fa-circle-notch fa-spin" v-if="isCreating"></i> ดูคำแนะนำ
      </a>
    </section>
  </article>
</template>
<script>
import Vue from "vue"
import axios from "axios"
import SlideInput from "../inputs/SlideInput.vue"
import RadioList from "../inputs/RadioList.vue"
import ConfigCreate from "../../config/create-plan-config.json"
import { sendAnalytic } from "../../utils/analytic"
import { GetPlanTitle } from "../../utils/meta"
import * as dataLayer from "../../utils/data-layer"

const SavingCompare = () => import("../charts/SavingCompare.vue")

export default {
  components: {
    SlideInput,
    RadioList,
    SavingCompare
  },
  props: { userID: String, env: Object, finnakies: String },
  data() {
    return {
      inputs: [],
      objQuery: {
        goalmoney: null,
        timeframe: null,
        initial: null,
        contribution: null,
        risklevel: null,
        plan: null
      },
      plan: "",
      profile: null,
      isLoading: false,
      isCreating: false,
      planInfo: null,
      currentURL: null,
    }
  },
  metaInfo: {
    title: GetPlanTitle()
  },
  computed: {},
  async created() {
    this.plan = this.$route.query.plan

    this.planInfo = ConfigCreate[this.plan]
    if (!this.planInfo) {
      this.$router.push({
        name: 500,
        params: {
          userID: this.userID,
          finnakies: this.finnakies,
          error: this.plan + " is unknown plan"
        },
        query: this.$route.query
      })

      return
    }

    if (this.planInfo.target) {
      this.objQuery.goalmoney = this.planInfo.target
    }

    if (this.planInfo.timeframe) {
      this.objQuery.timeframe = this.planInfo.timeframe
    }

    if (this.planInfo.risklevel) {
      this.objQuery.risklevel = this.planInfo.risklevel
    }

    this.currentURL = "create_plan_" + this.plan
    if (this.$route.query.initial) {
      this.currentURL = "redraft_plan_" + this.plan
    }
  },
  async mounted() {
    // add plan to qs
    let plan = this.$route.query.plan || ""
    if (plan) this.objQuery.plan = plan

    sendAnalytic({
      luid: this.userID,
      de: "line",
      cu: this.currentURL,
      ac: "open",
      ec: "create_flow",
      un: this.finnakies,
      et: "on_load"
    })

    // add cookie to qs
    if (this.finnakies) {
      this.objQuery.un = this.finnakies
    }

    // load config json to write input lists
    let configPlan = ConfigCreate[plan]
    if (configPlan && configPlan.inputs && configPlan.inputs.length > 0) {
      this.inputs = configPlan.inputs
      for (var i = 0; i <= this.inputs.length - 1; i++) {
        if (this.inputs[i] && this.inputs[i].name == "initial") this.objQuery.initial = this.inputs[i].default

        if (this.inputs[i] && this.inputs[i].name == "contribution") this.objQuery.contribution = this.inputs[i].default

        if (this.inputs[i] && this.inputs[i].name == "risklevel") this.objQuery.risklevel = this.inputs[i].default
      }
    }

    // add initial to qs
    let initial = this.$route.query.initial || ""
    if (initial) {
      this.objQuery.initial = parseInt(initial)
      this.findAndReplace("initial", parseInt(initial))
    }

    // add contribution to qsq
    let contribution = this.$route.query.contribution || ""
    if (contribution) {
      this.objQuery.contribution = parseInt(contribution)
      this.findAndReplace("contribution", parseInt(contribution))
    }

    // add risklevel to qs
    let risklevel = this.$route.query.risklevel || ""
    if (risklevel) {
      this.objQuery.risklevel = parseInt(risklevel)
      this.findAndReplace("risklevel", parseInt(risklevel))
    }
  },
  methods: {
    login() {
      window.location = "/login"
    },
    logout() {
      window.location = "/logout"
    },
    parseNumberFormat(num) {
      if (num) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      }
      return 0
    },
    inputData(val, name) {
      if (val && name) {
        Vue.set(this.objQuery, name, val)
      }
    },
    updateReturn(val) {
      Vue.set(this.objQuery, "return", val)
    },
    async submitCreate() {
      this.isCreating = true

      let userplan = {}

      const analyticObj = {
        luid: this.userID,
        de: "line",
        ac: "click_create_plan",
        ec: "create_flow",
        et: "on_click",
        un: this.finnakies,
        in: this.objQuery.initial,
        ri: this.objQuery.risklevel,
        pl: this.$route.query.plan.toUpperCase(),
        mo: this.objQuery.contribution,
        ta: this.objQuery.goalmoney,
        ti: this.objQuery.timeframe,
        cu: this.currentURL
      }

      userplan["line_user_id"] = this.userID
      userplan["plan_detail"] = this.objQuery
      try {
        const { data } = await axios.post(`/api/plan/private/save`, userplan)
        if (data.success) {
          sendAnalytic({
            ...analyticObj
          })
          dataLayer.clickCreatePlan({
            plan_type: analyticObj.pl,
            plan_name: analyticObj.pl,
            slot: 1,
            risk_level: analyticObj.ri,
            initial: analyticObj.in,
            purpose: "",
            target_amount: analyticObj.ta,
            timeframe: analyticObj.ti,
            contribution: analyticObj.mo,
            device: analyticObj.de
          })
          this.$liff.closeWindow()
        } else {
          alert(data.message)
        }
      } catch (err) {
        let code = null
        if (err.response) {
          code = err.response.status
        }

        if (!code) {
          this.$router.push({
            name: 500,
            params: {
              userID: this.userID,
              finnakies: this.finnakies,
              error: err.message
            },
            query: this.$route.query
          })
        }

        if (code === 400 || code === 401) {
          await this.$setItem("task", {
            method: "POST",
            url: "/api/plan/private/save",
            data: userplan
          })
          await this.$setItem("analytic_task", {
            ...analyticObj
          })
          window.location = "/login"
        } else {
          this.message = err.response.data

          // TODO: Make util for this
          let error = null

          let data = null
          if (err.response && err.response.data && err.response.data.data) {
            data = err.response.data.data
          }

          if (data) {
            error = data[0].key
            for (let i = 1; i < data.length; i++) {
              error += "," + data[i].key
            }
          }

          this.$router.push({
            name: 500,
            params: {
              userID: this.userID,
              finnakies: this.finnakies,
              error: error
            },
            query: this.$route.query
          })
        }
      }

      this.isCreating = false
    },
    findAndReplace(name, val) {
      let rs = this.inputs.find(function(row) {
        return row.name == name
      })
      rs.default = val
    }
  }
}
</script>
<style lang="scss" scoped>
#article-create {
  width: 100%;
  .header-create {
    @extend %padding-row;
    h1 {
      font-size: 20px;
      font-weight: bold;
      margin: 20px 0 0 0;
    }
    p {
      font-size: 14px;
      font-weight: normal;
      margin: 5px 0px 0px 0px;
      color: $color-secondary-text;
    }
  }
  .section-input {
    padding: 30px $padding-size 20px $padding-size;
    border-bottom: 1px solid $color-border;
  }
  .section-input-checked {
    padding: 0 8px;
    display: block;
    clear: both;
  }

  .spacer {
    margin-top: 62px;
    clear: both;
  }

  #cta-create {
    position: fixed;
    bottom: 0;
    width: 100%;
    left: 0;
    z-index: 99;
    text-align: center;

    .cta-btn {
      text-decoration: none;
      @extend %btn-primary;
      font-style: normal;
      font-stretch: normal;
      padding: 12.5px 0;
      width: -webkit-fill-available;
    }
  }
}
</style>




